module.exports = __webpack_public_path__ + "static/media/google-signin-logo.07619eda.svg";